module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-10-ae03a1cd163e9adac47254ef9a131fd9.png";